import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
    </div>
  );
}

export function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function ProtectedRoute({ role, children }) {
  const { user } = useAuth();
  if (user === undefined) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  return children;
}

export { Splash };
